import { faCircleCheck, faCircleExclamation } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Flex, Heading, TextLink } from '@modusign/design-system';

import fileHashFail from '@app/assets/file-hash-fail.svg';
import fileHashSuccess from '@app/assets/file-hash-success.svg';

import DocumentValidationResult from '../../types/DocumentValidationResult';
import FileHashResultPageLayout from '../FileHashResultPageLayout';

export interface FileHashResultPageProps {
  result: DocumentValidationResult;
  documentId: string | null;
  onResetResult: () => void;
}

export default function FileHashResult({
  result,
  documentId,
  onResetResult,
}: FileHashResultPageProps) {
  return (
    <>
      {result.isVerified ? (
        <FileHashResultPageLayout
          documentId={documentId}
          headerImageSrc={fileHashSuccess}
          result={result}
          resultMessage={
            <Flex fontSize="md" fontWeight="medium" mt={2}>
              <Box color="iconPositiveBase" fontSize="md" fontWeight="regular" mr={1}>
                <FontAwesomeIcon icon={faCircleCheck} />
              </Box>
              대상 문서의 원본 검증키가 원본과 일치합니다.
            </Flex>
          }
          resultTitle={
            <Heading color="textPositiveBase" fontSize="lg" fontWeight="medium" textAlign="center">
              문서가 원본입니다.
            </Heading>
          }
          onResetResult={onResetResult}
        />
      ) : (
        <FileHashResultPageLayout
          documentId={documentId}
          headerImageSrc={fileHashFail}
          result={result}
          resultMessage={
            <Flex alignItems="center" fontSize="md" fontWeight="medium" mt={2}>
              <Box color="iconNegativeBase" fontSize="md" fontWeight="regular" mr={1}>
                <FontAwesomeIcon icon={faCircleExclamation} />
              </Box>
              대상 문서의 원본 검증키가 원본과 일치하지 않습니다.
              <TextLink
                href="https://support.modusign.co.kr/87147033142"
                ml={1}
                rel="noopener noreferrer"
                target="_blank"
              >
                자세히
              </TextLink>
            </Flex>
          }
          resultTitle={
            <Heading color="textNegativeBase" fontSize="lg" fontWeight="medium" textAlign="center">
              문서가 원본이 아닙니다.
            </Heading>
          }
          onResetResult={onResetResult}
        />
      )}
    </>
  );
}
